import React, { useState } from "react";
import { NotificationManager as nm } from "react-notifications";
import Popup from "reactjs-popup";
import { addMatchDossier } from "shared/services/api-assistant.js";
import { prettifyId } from "shared/utils/graphql.js";

interface PopupAddMatchDossierProps {
  trigger: Object;
  onClose: func;
}

const PopupAddMatchDossier: React.FC<PopupAddMatchDossierProps> = ({ trigger, onClose }) => {
  const [name, setName] = useState("");

  const confirm = (close) => {
    addMatchDossier({
      handleSuccess: (v) => {
        if (v.errors) {
          nm.warning("Error while adding the dossier");
          return;
        }

        nm.info("The dossier has been added");
        if (onClose) onClose();
        close();
      },
      params: {
        name,
      },
    });
  };

  return (
    <div className="PopupAddMatchDossier">
      <Popup trigger={trigger} modal closeOnDocumentClick={false} onClose={onClose} className={"fade-in popup-md"}>
        {(close) => (
          <div>
            <div className="d-flex flex-row mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">Add a new dossier</h2>
              </div>
              <div className="flex-grow-0">
                <button className={"btn"} onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-end mt-3">
              <input
                type="text"
                className="form-control w-100"
                value={name}
                onChange={(v) => setName(v.target.value)}
                placeholder={"Name"}
                autoFocus
              />
              <div>
                <button className="btn btn-info text-white" disabled={name.length < 3} onClick={() => confirm(close)}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupAddMatchDossier;
